<template>
  <div class="mask" v-if="!isBind">
    <div class="content">
      <div class="title">绑定手机号</div>
      <van-field class="field-input" placeholder="手机号" v-model.trim="bindForm.mobilePhone" @blur="checkPhone" :error-message="errMsg.mobilePhone" clearable />
      <van-field class="field-input" placeholder="验证码" size="large" v-model.trim="bindForm.captcha" clearable :error-message="errMsg.captcha" @blur="checkVeriCode">
        <van-button slot="button" class="code-btn" size="small" :class="{ 'disable-btn': isDisable }" type="info" @click.prevent="sendVeriCode">
          {{ captchaText }}
        </van-button>
      </van-field>
      <van-button type="info" class="submit-btn" @click="register" id="userRegister">注&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;册</van-button>
      <div class="agree">
        点击“<span>注册</span>”，即表示您同意遵守
        <span @click="goRegLicense">「用户协议」</span>
        <span @click="goPrivacy">「隐私声明」</span>
      </div>
    </div>
    <!-- <van-dialog v-model="vcodeshow"
                @confirm="confirmsf"
                @close="closesf"
                show-cancel-button>
      <van-field v-model="sms"
                 center
                 clearable
                 placeholder="请输入验证码"
                 class="sf">
        <template #button>
           <van-image @click="ckpicturecaptcha" width="80" height="35" :src="sf"/>
        </template>
      </van-field>
    </van-dialog> -->
  </div>
</template>

<script>
import { stopRestoreBobyMove } from '../util/tools'
import { CHECK_MOBILE_PHONE } from '../util/validate'
import { GetVerificationCode, WechatUserBindPhone } from '../api/user'
import { SetGetAuthInfo } from '../util/auth'

const storeKey = 'bindFormInfo'

export default {
  name: 'FroceBind',
  components: {},
  mixins: [],
  props: {},

  data() {
    return {
      sf:'',
      sms: '',
      // vcodeshow: false,
      bindForm: {
        mobilePhone: '',
        captcha: ''
      },
      errMsg: {
        mobilePhone: '',
        captcha: ''
      },
      isDisable: false,
      captchaText: '获取验证码'
    }
  },

  computed: {
    isBind: function() {
      // console.log(this.$store.state.userInfo)
      return (
        !!this.$store.state.userInfo.mobilePhone && !this.$route.meta.notForce
      )
    }
  },

  watch: {
    isBind: function(newVal) {
      if (newVal) {
        stopRestoreBobyMove.resotre()
      }
    }
  },

  created() {
    // console.log('forceBindCreated')
  },

  mounted() {
    const bindFormInfo = sessionStorage.getItem(storeKey)
    this.bindForm = bindFormInfo
      ? JSON.parse(bindFormInfo)
      : { mobilePhone: '', captcha: '' }
    if (!this.isBind) {
      stopRestoreBobyMove.stop()
    } else {
      stopRestoreBobyMove.resotre()
    }
  },
  update() {
    if (!this.isBind) {
      stopRestoreBobyMove.stop()
    } else {
      stopRestoreBobyMove.resotre()
    }
  },
  destroyed() {},

  methods: {
    // ckpicturecaptcha(){
    //   const d = new Date().getTime()
    //   this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.bindForm.mobilePhone}&id=${d}`
    // },
    async confirmsf() {
      try {
        await GetVerificationCode({ mobilePhone: this.bindForm.mobilePhone })
        this.captchaText = '获取中...'
        this.isDisable = true
        let countDown = 60
        this.captchaText = `重新获取(${countDown})`
        this.veriInterval = setInterval(() => {
          countDown = countDown - 1
          if (countDown === 0) {
            clearInterval(this.veriInterval)
            this.isDisable = false
            this.captchaText = `获取验证码`
          } else {
            this.captchaText = `重新获取(${countDown})`
          }
        }, 1000)
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    closesf() {
      this.isDisable = false
    },
    async sendVeriCode() {
      if (!this.bindForm.mobilePhone) {
        this.$notify({ type: 'danger', message: '请填写手机号' })
        return
      }
      if (!CHECK_MOBILE_PHONE(this.bindForm.mobilePhone)) {
        this.$notify({ type: 'danger', message: '手机号格式不正确' })
        return
      }
      if (this.isDisable) {
        return
      }
      this.confirmsf()
      // const d = new Date().getTime()
      // this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.bindForm.mobilePhone}&id=${d}`
      // this.vcodeshow = true
    },
    checkPhone() {
      if (!this.bindForm.mobilePhone) {
        this.errMsg.mobilePhone = '请填写手机号码！'
        return false
      } else if (!CHECK_MOBILE_PHONE(this.bindForm.mobilePhone)) {
        this.errMsg.mobilePhone = '手机号格式不正确！'
        return false
      } else {
        this.errMsg.mobilePhone = ''
        return true
      }
    },
    checkVeriCode() {
      if (!this.bindForm.captcha) {
        this.errMsg.captcha = '验证码必填！'
        return false
      }
      this.errMsg.captcha = ''
      return true
    },
    async register() {
      if (this.checkPhone() && this.checkVeriCode()) {
        try {
          const res = await WechatUserBindPhone(
            {
              mobilePhone: this.bindForm.mobilePhone,
              captcha: this.bindForm.captcha,
              openId: this.$store.state.userInfo.openId
            },
            { isShow: true, text: '提交中...' }
          )
          // console.log('forceBind', res)
          SetGetAuthInfo.setInfo(res)
          this.$store.commit('SET_USER_INFO', res)
        } catch (e) {
          this.$notify({ type: 'danger', message: e.message })
        }
      }
    },
    goRegLicense() {
      const bindFormInfo = JSON.stringify(this.bindForm)
      sessionStorage.setItem(storeKey, bindFormInfo)
      stopRestoreBobyMove.resotre()
      this.$router.push({ path: '/register-protocol' })
    },
    goPrivacy() {
      const bindFormInfo = JSON.stringify(this.bindForm)
      sessionStorage.setItem(storeKey, bindFormInfo)
      stopRestoreBobyMove.resotre()
      this.$router.push({ path: '/privacy-statement' })
    }
  }
}
</script>

<style scoped lang="scss">
.mask {
  position: fixed;
  z-index: 899;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  background-color: #fff;
  padding: px2rem(30, 375) px2rem(15, 375);
  width: px2percent(343, 375);
  border-radius: px2rem(5, 375);
  max-width: 750px;

  .title {
    color: #1c1c1c;
    margin-bottom: px2rem(15, 375);
  }

  .field-input {
    font-size: px2rem(15, 375);
    color: #272727;
    border-bottom: 1px solid #dbdbdb;

    /deep/ input {
      color: #272727;
    }
  }

  .code-btn {
    background: #1C9EE4;
    outline: none;
    border: none;
  }

  .submit-btn {
    @include textCenter;
    width: 100%;
    margin-top: px2rem(20, 375);
    border-radius: px2rem(10, 375);
    font-size: px2rem(22, 375);
    background: linear-gradient(to right, #DB0003, #FF6C61);
    outline: none;
    border: none;
  }
  .disable-btn {
    background: #aaa;
    color: #fff;
    border: 1px solid transparent;
  }
  .agree {
    font-size: px2rem(13, 375);
    line-height: 1.5;
    color: #999;
    margin-top: px2rem(10, 375);
    text-align: justify;

    span {
      color: #FD514A;
    }
  }
}
</style>
